import FlagIcon from "@mui/icons-material/Flag";
import {
  Alert,
  Button,
  IconButton,
  List,
  ListItem,
  Stack,
  Typography,
} from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { Panel } from "@poseidon/ui/components/Panel";
import { db } from "@poseidon/firebase";
import { getDate } from "@poseidon/firebase/timestamp";
import { doc } from "firebase/firestore";
import { useEffect } from "react";
import { useDocumentData } from "react-firebase-hooks/firestore";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import { prettyOpenBankingLabel } from "./prettyOpenBankingLabel";

export const OpenBankingRedFlags = ({ sailorId }) => {
  const [openBanking, loading, error] = useDocumentData(
    doc(db, "sailorRiskProfiles", sailorId, "openBanking", "current")
  );

  const { setError } = useErrorMessage();

  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [error, setError]);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  if (!openBanking?.data?.redFlags?.length) {
    return null;
  }

  return (
    <Panel title="Open Banking Red Flags">
      {loading && <LinearProgress />}
      {!loading && openBanking?.data && (
        <Stack spacing={2} mt={1}>
          {openBanking?.data?.redFlags?.length > 0 && (
            <Typography variant="body1">
              <List component={Stack} direction="row">
                {openBanking?.data?.redFlags?.map((redFlag) => (
                  <>
                    <Dialog onClose={handleClose} open={open}>
                      <DialogTitle
                        sx={{ pr: 6, backgroundColor: "#f44336", mb: 2 }}
                        color="#fff"
                      >
                        Red Flag details
                        <IconButton
                          aria-label="close"
                          onClick={handleClose}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: "#fff",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Field</TableCell>
                              <TableCell>Value</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Object.entries(redFlag).map(([key, value]) => (
                              <TableRow key={key}>
                                <TableCell>{key}</TableCell>
                                <TableCell>
                                  {prettyOpenBankingLabel(value)}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </DialogContent>
                    </Dialog>

                    <ListItem sx={{ pl: 0 }}>
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={handleOpen}
                      >
                        <FlagIcon color="error" /> {redFlag.label}
                      </Button>
                    </ListItem>
                  </>
                ))}
              </List>
            </Typography>
          )}
          <Typography variant="caption">
            Last Updated:{" "}
            {getDate(openBanking?.lastFetched)?.toLocaleString() ?? "Unknown"}
          </Typography>
        </Stack>
      )}
    </Panel>
  );
};
